import { useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/base/Breadcrumb";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";

const sorted = [...newsList].sort((a, b) => b.date.localeCompare(a.date));

export default function NewsPage() {
  const [visible, setVisible] = useState(5);
  const items = sorted.slice(0, visible);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <title>影视资讯 - 91看片影视新闻与深度评论</title>
      <meta
        name="description"
        content="91看片影视资讯频道，提供最新影视新闻、行业观察、深度影评与专题内容，按时间更新，助你掌握影视圈动态。"
      />
      <SiteHeader />

      <main className="flex-1">
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto max-w-site px-4 py-6 md:px-6 md:py-8">
            <Breadcrumb items={[{ label: "影视资讯" }]} />
            <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              影视资讯
            </h1>
            <p className="mt-2 max-w-3xl text-sm leading-6 text-foreground-600">
              影视新闻、深度评论与专题观察，按发布时间实时更新，为你呈现行业脉动与观影指南。
            </p>
          </div>
        </section>

        <div className="mx-auto max-w-site px-4 py-8 md:px-6">
          {items.length > 0 ? (
            <div className="flex flex-col gap-4">
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                {items.map((article) => (
                  <NewsCard key={article.id} article={article} />
                ))}
              </div>
              {visible < sorted.length ? (
                <div className="mt-4 flex justify-center">
                  <button
                    type="button"
                    onClick={() => setVisible((prev) => prev + 4)}
                    className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    <i className="ri-add-line"></i>
                    加载更多资讯
                  </button>
                </div>
              ) : (
                <p className="mt-4 text-center text-sm text-foreground-400">
                  已加载全部 {sorted.length} 篇资讯
                </p>
              )}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 py-20 text-center">
              <i className="ri-article-line text-4xl text-foreground-300"></i>
              <p className="mt-3 text-base font-medium text-foreground-800">
                暂无资讯内容
              </p>
              <p className="mt-1 text-sm text-foreground-500">
                内容正在更新中，请稍后再来查看
              </p>
            </div>
          )}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}